import { Reports } from '../primary-record-types';

export const reportTypes: Reports.ReportType[] = ['summary-report', 'active-medications'];
